import { AGruppoStudioService } from './../a-gruppo-studio.service';
import { Component, AfterViewInit, OnInit } from '@angular/core';

import * as Prism from 'prismjs';
import { ListGruppiStudioDTO, SelectDTO } from 'src/app/model/newModel';
import { Router, ActivatedRoute } from '@angular/router';
import { NgxSmartModalService, NgxSmartModalComponent } from 'ngx-smart-modal';
import { SharedService } from '../../../../shared/shared.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { AbstractListComponent } from '../../../../model/AbstractListComponent';
import { GoToModel, GruppoStudioDTO } from '../../../../model/newModel';
import * as _ from 'lodash';

@Component({
  selector: 'app-list-gruppi-studio',
  templateUrl: './list-gruppi-studio.component.html',
  styleUrls: ['./list-gruppi-studio.component.css'],
})
export class ListGruppiStudioComponent
  extends AbstractListComponent
  implements AfterViewInit, OnInit {
  listGruppiStudio: ListGruppiStudioDTO;
  idSessioneOla: string;
  idCorsoLaurea: string;
  idInstructor: string;
  idGiorno: string;
  nomeGruppo: string;
  sessioniOla: SelectDTO[];
  instructors: SelectDTO[];
  corsiLaurea: SelectDTO[];
  giorni: SelectDTO[];

  ngOnInit(): void {
    super.ngOnInit();
    this.getSessioneOlaAttiva();
    this.loadInstructors();
    this.loadCorsiLaurea();
    this.loadGiorniSettimana();

    this.route.queryParams.subscribe((params) => {
      if (!!params && !!params.goBack) {
        const goBack: GoToModel = JSON.parse(params.goBack);
        const currentParams: any = JSON.parse(goBack.params);
        this.idSessioneOla = currentParams.idSessioneOla;
        this.nomeGruppo = currentParams.nomeGruppo;
        this.idInstructor = currentParams.idInstructor;
        this.idCorsoLaurea = currentParams.idCorsoLaurea;
        this.idGiorno = currentParams.idGiorno;
        this.idVaiA = currentParams.idVaiA;
        this.listGruppiStudio = new ListGruppiStudioDTO();
        this.listGruppiStudio.take = currentParams.take;
        this.goToPage(this.idVaiA, null);
      }
    });
  }

  loadGiorniSettimana() {
    this.sharedService.selectGiorniSettimana().subscribe(
      (result) => {
        const allTypes = new SelectDTO();
        allTypes.value = '';
        allTypes.viewValue = 'TUTTI';
        this.giorni = result.list;
        this.giorni.unshift(allTypes);
        this.giorni = result.list;
      },
      (error) => {
        console.log('Errore selectGiorniSettimana');
      }
    );
  }

  loadCorsiLaurea() {
    this.sharedService.selectCorsiLaurea().subscribe(
      (result) => {
        const allTypes = new SelectDTO();
        allTypes.value = '';
        allTypes.viewValue = 'TUTTI';
        this.corsiLaurea = result.list;
        this.corsiLaurea.unshift(allTypes);
        this.corsiLaurea = result.list;
      },
      (error) => {
        console.log('Errore selectCorsiLaurea');
      }
    );
  }

  loadInstructors() {
    this.sharedService.selectInstructorsAttivi().subscribe(
      (result) => {
        const allTypes = new SelectDTO();
        allTypes.value = '';
        allTypes.viewValue = 'TUTTI';
        this.instructors = _.orderBy(result.list, 'viewValue', 'asc');
        this.instructors.unshift(allTypes);
      },
      (error) => {
        console.log('Errore selectInstructorsAttivi');
      }
    );
  }

  getSessioneOlaAttiva() {
    this.sharedService.getSessioneOlaActive().subscribe(
      (result) => {
        this.loadSessioniOla();
        this.idSessioneOla = '' + result.id;
      },
      (error) => {
        console.log('Errore getSessioneOlaActive');
      }
    );
  }

  loadSessioniOla() {
    this.sharedService.selectSessioniOla(false).subscribe(
      (result) => {
        this.sessioniOla = result.list;
      },
      (error) => {
        console.log('Errore selectSessioniOla');
      }
    );
  }

  resetOther(tipo: string) {
    switch (tipo) {
      case 'NOME':
        this.idCorsoLaurea = null;
        this.idGiorno = null;
        this.idInstructor = null;
        break;
      case 'INSTRUCTOR':
        this.idCorsoLaurea = null;
        this.idGiorno = null;
        this.nomeGruppo = null;
        break;
      case 'CORSO_LAUREA':
        this.nomeGruppo = null;
        this.idGiorno = null;
        this.idInstructor = null;
        break;
      case 'GIORNI':
        this.idCorsoLaurea = null;
        this.nomeGruppo = null;
        this.idInstructor = null;
        break;
    }
  }

  duplicaGruppo(idGruppo: number) {
    this.spinner.show();
    this.aGruppoStudioService.duplicaGruppo(idGruppo).subscribe(
      (result) => {
        this.spinner.hide();
        this.sharedService.openOkModal();
        this.modalSubscribe = this.ngxSmartModalService
          .getModal('okModal')
          .onClose.subscribe((modal: NgxSmartModalComponent) => {
            this.sharedService.goTo(this.goBackModel());
          });
      },
      (error) => {
        this.spinner.hide();
        console.log('Errore duplicaGruppo');
      }
    );
  }

  disabilita(id: number) {
    this.aGruppoStudioService
      .abilitaDisabilita(id, false)
      .subscribe((result) => {
        if (result) {
          this.sharedService.openOkModal();
          this.modalSubscribe = this.ngxSmartModalService
            .getModal('okModal')
            .onClose.subscribe((modal: NgxSmartModalComponent) => {
              this.sharedService.goTo(this.goBackModel());
            });
        }
      });
  }

  disabilitaAbilita(id: number, value: boolean) {
    if (value) {
      this.disabilita(id);
    } else {
      this.abilita(id);
    }
  }

  abilita(id: number) {
    this.aGruppoStudioService
      .abilitaDisabilita(id, true)
      .subscribe((result) => {
        if (result) {
          this.sharedService.openOkModal();
          this.modalSubscribe = this.ngxSmartModalService
            .getModal('okModal')
            .onClose.subscribe((modal: NgxSmartModalComponent) => {
              this.sharedService.goTo(this.goBackModel());
            });
        }
      });
  }

  eliminaGruppoStudio(id: number) {
    this.aGruppoStudioService.getGruppoStudio(id).subscribe(
      (result) => {
        if (!!result.studenti && result.studenti.studenti.length > 0) {
          this.spinner.hide();
          const text =
            'il gruppo non può essere eliminato perchè ha studenti associati';
          this.sharedService.openWarningModal(text);
        } else {
          this.aGruppoStudioService.eliminaGruppoStudio(id).subscribe(
            (result2) => {
              if (result2) {
                this.sharedService.openOkModal();
                this.modalSubscribe = this.ngxSmartModalService
                  .getModal('okModal')
                  .onClose.subscribe((modal: NgxSmartModalComponent) => {
                    this.sharedService.goTo(this.goBackModel());
                  });
              } else {
                this.sharedService.openKoModal();
              }
              this.spinner.hide();
            },
            (error) => {
              this.spinner.hide();
              console.log('Errore eliminaGruppoStudio');
            }
          );
        }
      },
      (error) => {
        this.spinner.hide();
        console.log('Errore getGruppoStudio');
      }
    );
  }

  search(
    idSessioneOla: string,
    nomeGruppo: string,
    idInstructor: string,
    idCorsoLaurea: string,
    idGiorno: string
  ) {
    this.spinner.show();
    this.aGruppoStudioService
      .search(Number(idSessioneOla), nomeGruppo, idInstructor, idCorsoLaurea, idGiorno)
      .subscribe(
        (result) => {
          this.listGruppiStudio = result;
          this.calcolaListVaiA(this.listGruppiStudio.pages);
          this.idVaiA = '' + (this.listGruppiStudio.currentPage - 1);
          this.spinner.hide();
        },
        (error) => {
          console.log('Errore search');
          this.spinner.hide();
        }
      );
  }

  goToGruppoStudioEditDetail(
    idGruppoStudio: number,
    activeSessioneOla: boolean
  ) {
    if (activeSessioneOla) {
      this.router.navigate(['/a-gruppo-studio/modifica'], {
        queryParams: {
          idGruppoStudio: idGruppoStudio,
          goBack: JSON.stringify(this.goBackModel()),
        },
      });
    } else {
      const text =
        'il gruppo non può essere modificato perche la sessione del gruppo è chiusa';
      this.sharedService.openWarningModal(text);
    }
  }

  goToGruppoStudioDetail(idGruppoStudio: number) {
    this.router.navigate(['/a-gruppo-studio/dettaglio'], {
      queryParams: {
        idGruppoStudio,
        goBack: JSON.stringify(this.goBackModel()),
      },
    });
  }

  private goBackModel(): GoToModel {
    const params = {
      idVaiA: this.idVaiA,
      take: this.listGruppiStudio.take,
      idSessioneOla: this.idSessioneOla,
      nomeGruppo: this.nomeGruppo,
      idInstructor: this.idInstructor,
      idCorsoLaurea: this.idCorsoLaurea,
      idGiorno: this.idGiorno,
    };
    const goBackModel = new GoToModel();
    goBackModel.url = '/a-gruppo-studio/list';
    goBackModel.params = JSON.stringify(params);
    return goBackModel;
  }

  contaStudenti(idGruppoStudio: number) {
    this.spinner.show();
    this.aGruppoStudioService.getGruppoStudio(idGruppoStudio).subscribe(
      (result: GruppoStudioDTO) => {
        const text =
          'STUDENTI PRESENTI IN ' +
          result.nome +
          ': ' +
          result.studenti.studenti.length;
        this.sharedService.openOkModal(text);
        this.spinner.hide();
      },
      (error) => {
        console.log('Errore conta studente');
        this.spinner.hide();
      }
    );
  }

  /**
   * @method ngAfterViewInit
   */
  ngAfterViewInit() {
    Prism.highlightAll();
  }

  constructor(
    public ngxSmartModalService: NgxSmartModalService,
    private route: ActivatedRoute,
    public router: Router,
    private sharedService: SharedService,
    private spinner: NgxSpinnerService,
    private aGruppoStudioService: AGruppoStudioService
  ) {
    super();
  }

  goToPage(idVaiA: string, event: any) {
    this.spinner.show();
    this.aGruppoStudioService
      .goToPage(
        Number(this.idSessioneOla),
        this.nomeGruppo,
        this.idInstructor,
        this.idCorsoLaurea,
        this.idGiorno,
        idVaiA,
        this.listGruppiStudio.take
      )
      .subscribe(
        (result) => {
          this.listGruppiStudio = result;
          this.calcolaListVaiA(this.listGruppiStudio.pages);
          this.idVaiA = '' + (this.listGruppiStudio.currentPage - 1);
          this.spinner.hide();
        },
        (error) => {
          console.log('Errore search goToPage');
          this.spinner.hide();
        }
      );
  }

  nextPage(skip: number, take: number, count: number) {
    this.spinner.show();
    this.aGruppoStudioService
      .nextPage(
        Number(this.idSessioneOla),
        this.nomeGruppo,
        this.idInstructor,
        this.idCorsoLaurea,
        this.idGiorno,
        skip,
        take,
        count
      )
      .subscribe(
        (result) => {
          this.listGruppiStudio = result;
          this.calcolaListVaiA(this.listGruppiStudio.pages);
          this.idVaiA = '' + (this.listGruppiStudio.currentPage - 1);
          this.spinner.hide();
        },
        (error) => {
          console.log('Errore search next');
          this.spinner.hide();
        }
      );
  }

  previousPage(skip: number, take: number) {
    this.spinner.show();
    this.aGruppoStudioService
      .previousPage(
        Number(this.idSessioneOla),
        this.nomeGruppo,
        this.idInstructor,
        this.idCorsoLaurea,
        this.idGiorno,
        skip,
        take
      )
      .subscribe(
        (result) => {
          this.listGruppiStudio = result;
          this.calcolaListVaiA(this.listGruppiStudio.pages);
          this.idVaiA = '' + (this.listGruppiStudio.currentPage - 1);
          this.spinner.hide();
        },
        (error) => {
          console.log('Errore search previous');
          this.spinner.hide();
        }
      );
  }
}
